module.exports = __webpack_public_path__ + "static/media/CABO-FLEX.aa380e0b.png";